<template>
	<div :class="$style['input-wrapper']">
		<div
			:class="$style['input']"
			@click="handleDropdownOpen"
		>
			<span>{{ value.name || $t('common.fields.select') }}</span>
			<FontAwesomeIcon
				:icon="['fal', 'calendar-alt']"
				size="sm"
			/>
		</div>
		<DropdownMenu
			ref="dropdown"
			:class="$style['input__dropdown']"
		>
			<ul :class="$style['input__dropdown-list']">
				<li
					v-for="item in list"
					:key="item.id"
					:class="[$style['input__dropdown-list-item'], {
						[$style['input__dropdown-list-item--active']]: item.id === activeItem
					}]"
					@mouseover="activeItem = item.id"
					@click="handleMenuSelect(item)"
				>
					{{ item.name }}
				</li>
			</ul>
		</DropdownMenu>
	</div>
</template>

<script>
import DropdownMenu from '@c:essentials/DropdownMenu'
export default {
	name: 'BaseMenuDropdown',
	components: {
		DropdownMenu
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		list: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		},
		value: {
			type: Object,
			default: () => ({
				name: null,
				id: null
			})
		}
	},
	data () {
		return {
			activeItem: null
		}
	},
	created () {
		if (this.value) {
			this.activeItem = this.value.id
		} else {
			this.activeItem = this.list[0].id
		}
	},
	methods: {
		handleDropdownOpen () {
			if (!this.disabled) {
				this.$refs['dropdown'].open()
			}
		},
		handleMenuSelect (item) {
			this.$emit('change', item)
			this.activeItem = item.id
			this.$refs['dropdown'].close()
		}
	}

}
</script>
<style lang="scss" module>
    .input-wrapper {
        height: 40px;
        position: relative;
        width: 233px;
    }

    .input {
        padding: $gutter $gutter * 2;
        background-color: getColor(surface);
        border-radius: 24px;
        box-shadow: 0 1px 2px 0 getColor(shadow-light);
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:hover {
            cursor: pointer;
            font-weight: bold;
        }

        &__dropdown {
            border-radius: 24px;
            position: absolute;
            left: 0;
            right: 0;
            top: -2px;
        }

        &__dropdown-list {
            list-style: none;
            margin: 0;
            padding: $gutter $gutter * 2;
        }

        &__dropdown-list-item {
            padding: calc($gutter / 2) 0;
            margin: 0;
            transition: color 0.12s ease;

            &--active {
                cursor: pointer;
                font-weight: bold;
                color: getColor(primary);
            }
        }
    }
</style>
